export default __webpack_public_path__ + "static/img-art-pandas-profiling-9-02305a67eb52f67d4597e2940503f0d4.webp";